<template>
  <b-row>
    <b-col md="3" class="mb-3 mb-md-0">
      <div class="filter-wrapper border rounded">
        <b-input-group prepend=" ">
          <b-form-input
            placeholder="Search"
            v-model="search"
            id="orders-dine-in-search"
            @input="applySearch"
          >
          </b-form-input>
        </b-input-group>
      </div>
    </b-col>
    <b-col md="4" class="mb-3 mb-md-0">
      <b-input-group
        id="orders-dine-in-status-wrapper"
        class="rounded bg-white"
      >
        <b-form-select
          v-model="selectedStatusFilter"
          id="orders-dine-in-status"
          :options="statusOptions"
          class="border-0 rounded-left shadow-none"
          :disabled="!selectedStatusColumnFilter"
        />
        <template slot="append">
          <b-dropdown
            id="order-status-advanced-filter"
            :text="
              selectedStatusColumnFilter
                ? selectedStatusColumnFilter.label
                : 'Advanced'
            "
            variant="default"
            toggle-class="text-primary shadow-none pr-1"
            menu-class="p-0"
            no-caret
          >
            <b-dropdown-item
              v-for="(columnFilter, columnFilterIndex) of statusAdvancedOptions"
              :key="`column-filter-${columnFilterIndex}-${columnFilter.value}`"
              class="px-2"
              @click="handleChangeStatusColumnFilter(columnFilter)"
            >
              {{ columnFilter.label }}
              <img
                width="15"
                height="15"
                src="@/assets/images/checked-symbol.svg"
                alt=""
                class="ml-1"
                v-if="
                  selectedStatusColumnFilter &&
                  selectedStatusColumnFilter.value === columnFilter.value
                "
              />
            </b-dropdown-item>
          </b-dropdown>
          <i
            :class="[
              'bi bi-chevron-down',
              { 'mr-2': !selectedStatusColumnFilter },
            ]"
            aria-hidden="true"
          ></i>
        </template>
        <template slot="append">
          <b-button
            role="button"
            variant="default"
            @click="handleChangeStatusColumnFilter(null)"
            class="shadow-none"
            v-if="selectedStatusColumnFilter"
          >
            <i
              class="bi bi-x-circle-fill text-secondary"
              aria-hidden="true"
            ></i>
          </b-button>
        </template>
      </b-input-group>
    </b-col>
    <b-col md="3">
      <date-range-picker
        :min-date="UNIX_DATE"
        icon="bi-calendar"
        @onDateRangeChange="handleDateRangeChange"
        @clearDateRange="applySearch()"
        show-clear-button
        :isBorder="true"
      />
    </b-col>
  </b-row>
</template>

<script>
import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import DateRangePicker from "@/components/common/DateRangePicker";
import commonMixins from "@/mixins/common";
import _ from "lodash";

export default defineComponent({
  components: { DateRangePicker },
  mixins: [commonMixins],
  setup(props, { emit }) {
    const search = ref(null);
    const selectedStatusFilter = ref(null);
    const selectedStatusColumnFilter = ref(null);
    const statusAdvancedOptions = [
      { value: "order_transaction_status", label: "Order Status" },
      { value: "payment_status", label: "Payment Status" },
    ];
    const statusOptionsList = {
      order_transaction_status: [
        { text: "Preparing", value: "in_process" },
        { text: "Served", value: "completed" },
        { text: "Cancelled", value: "cancelled" },
      ],
      payment_status: [
        { text: "Processing", value: "pending" },
        { text: "Completed", value: "success" },
        { text: "Failed", value: "failed" },
      ],
    };
    const statusOptions = computed(() => {
      const firstItem = { text: "All Status", value: null };
      if (selectedStatusColumnFilter.value)
        return [firstItem].concat(
          statusOptionsList[selectedStatusColumnFilter.value.value]
        );
      else return [firstItem];
    });
    const dateRangeFilterValue = ref({
      startDate: "",
      endDate: "",
    });
    const applySearch = _.debounce(() => {
      const payload = {};
      if (search.value) payload["keyword"] = search.value;
      if (selectedStatusFilter.value)
        payload[selectedStatusColumnFilter.value.value] =
          selectedStatusFilter.value;
      if (
        !!dateRangeFilterValue.value.startDate &&
        !!dateRangeFilterValue.value.endDate
      )
        payload["date_range"] = {
          start: dateRangeFilterValue.value.startDate,
          end: dateRangeFilterValue.value.endDate,
        };
      emit("setOrdersDineInPageSearch", payload);
    }, 300);
    const handleDateRangeChange = ({ from, to }) => {
      dateRangeFilterValue.value = {
        startDate: from,
        endDate: to,
      };
    };
    const handleChangeStatusColumnFilter = (filter) => {
      selectedStatusColumnFilter.value = filter;
      selectedStatusFilter.value = null;
    };

    watch(selectedStatusFilter, () => {
      applySearch();
    });

    watch(dateRangeFilterValue, () => {
      const { startDate, endDate } = dateRangeFilterValue.value;
      if (!!startDate && !!endDate) applySearch();
    });

    return {
      search,
      applySearch,
      selectedStatusFilter,
      statusOptions,
      handleDateRangeChange,
      statusAdvancedOptions,
      selectedStatusColumnFilter,
      handleChangeStatusColumnFilter,
    };
  },
});
</script>

<style lang="scss" scoped>
#orders-dine-in-status-wrapper {
  box-shadow: 0 2px 4px 0 #e3e3e3;
  border: 1px solid #dee2e6 !important;
  #orders-dine-in-status {
    background: none !important;
  }
  .input-group-append {
    align-items: center;
    i.bi {
      font-size: 12px;
    }
  }
}
</style>

<style lang="scss">
#order-status-advanced-filter .dropdown-toggle {
  font-size: 12px;
}
</style>
